import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

/** ítems de la barra */
export interface TopAction {
  id: string;
  src: string;     // SVG path data
  label: string;    // texto del tooltip
  badge?: number | string;   // opcional
}

@Component({
  standalone: true,
  selector  : 'app-top-actions',
  imports   : [CommonModule],
  styleUrls : ['./top-actions.component.scss'],
  template  : `
    <button *ngFor="let act of actions"
            class="action-btn"
            [class.active]="act.id===active"
            (click)="choose(act)">
      <img [src]="act.src" alt="" />

      <span class="tooltip">{{ act.label }}</span>

      <span class="badge" *ngIf="act.badge">{{ act.badge }}</span>
    </button>
  `
})
export class TopActionsComponent {
  @Input()  actions: TopAction[] = [];
  @Input()  active?: string;
  @Output() actionClick = new EventEmitter<TopAction>();

  choose(act: TopAction){ this.actionClick.emit(act); }
}
